<template>
  <div
    :style="containerConfigStyle"
    class="advance-imgTxt-four--container"
  >
    <div
      class="card-container--row"
      v-for="groupIndex in Math.ceil(cardList.length/rowsNum)"
      :key="groupIndex"
      :style="{
        paddingBottom: `${verticalGutter}px`,
        maxWidth: maxWidth,
        margin: '0 auto'
      }"
    >
      <div
        class="card-container--col"
        :class="{
          'hover-animation': imageConfig.hoverAnimation,
          'is-click': !!item.link
        }"
        :style="{
          marginRight: `${gutter}px`,
          width: colWidth,
        }"
        v-for="(item, index) in cardList.slice((groupIndex-1)*rowsNum, groupIndex*rowsNum)"
        :key="`${groupIndex}_${index}`"
      >
        <card-container
          :cardData="item"
          :cardConfig="cardConfig"
          :imageConfig="imageConfig"
          :textConfig="textConfig"
          :layout="layout"
          @click="handleClick(((groupIndex - 1) * rowsNum) + index, item)"
        ></card-container>
      </div>
    </div>
  </div>
</template>

<script>
import cardContainer from './cardContainer.vue'
import mixin from '../../utils/mixin'
import { transfCssUtil } from '../../utils/index'
export default {
  components: {
    cardContainer
  },
  mixins: [mixin],
  props: {
    containerConfig: {
      type: Object
    },
    maxWidth: {
      type: String,
      default: '1200px',
    },
    cardList: {
      type: Array,
      default: () => [],
      required: true
    },
    cardConfig: {
      type: Object,
      default: () => ({}),
      required: true
    },
    imageConfig: {
      type: Object,
      default: () => ({}),
      required: true
    },
    textConfig: {
      type: Object,
      default: () => ({}),
      required: true
    },
    layout: {
      type: String,
      default: 'top-image-bottom-text'
    }
  },
  data () {
    return {}
  },
  computed: {
    containerConfigStyle () {
      return {
        ...transfCssUtil(this.containerConfig),
        backgroundImage: `url(${this.containerConfig.backgroundImage})`
      }
    },
    colWidth () {
      const meanGutter = (this.gutter * (this.rowsNum - 1)) / this.rowsNum
      return `calc(${100 / this.rowsNum}% - ${meanGutter}px)`
    },
    gutter () {
      return this.cardConfig.gutter || 0
    },
    verticalGutter () {
      return this.cardConfig.verticalGutter || this.gutter
    },
    rowsNum () {
      return Number(this.cardConfig.spanNum || 1)
    },
    spanNum () {
      return 24 / this.rowsNum
    }
  },
  methods: {
    handleClick (index, data) {
      if (!this.mode) {
        this.handleClickItem(index, data)
        // this.$emit('curClickNode', {
        //   idx: index,
        //   dom: 3
        // })
      } else {
        this.openUrl(data.link)
        // console.log('-------------', data)
      }
    }
  },
  created() {}
}
</script>

<style lang="stylus" scoped>
.advance-imgTxt-four--container
  background-repeat no-repeat
  background-size cover
  background-position 50%
.card-container--row
  display flex
  .card-container--col
    // flex 1
    &:last-child
      margin-right 0 !important
    &.is-click,
    &.hover-animation
      cursor pointer
      :deep(.image-wrapper--full-cover) .el-image__inner
        transition: transform 0.6s ease;
      &:hover :deep(.image-wrapper--full-cover) .el-image__inner
        transform scale(1.1)
  &:last-child
    padding-bottom 0 !important
</style>
